import { RokaApiErrorResponse } from "../api/adminApi";

export class RokaApiError extends Error {
  public readonly errorType: string;
  public readonly requestId: string;

  constructor(errorResponse: RokaApiErrorResponse) {
    super(errorResponse.errorMessage);
    this.name = "CreateUserError";
    this.errorType = errorResponse.errorType;
    this.requestId = errorResponse.requestId;

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RokaApiError);
    }
  }
}
